import React from "react";
import { NavLink } from "react-router-dom";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { getLoggedInUserRole } from '../../services/localstorage'

import './style.css'

var ps;

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.activeRoute.bind(this);
    this.sidebar = React.createRef();
    this.state = {
      userRole: getLoggedInUserRole()
    }
  }

  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName, className) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? className : "";
  }

  isSubROute(subRoutes, className) {
    for (let index = 0; index < subRoutes.length; index++) {
      const subRoute = subRoutes[index];
      if (this.props.location.pathname.indexOf(subRoute.path) > -1) {
        return className
      }
    }

    return ''
  }

  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }

  render() {
    return (
      <div
        className="sidebar"
        data-color={this.props.bgColor}
        data-active-color={this.props.activeColor}
      >
        <div className="logo">
          <a className="simple-text logo-mini">
            <div className="logo-img">
              <img src={require("assets/img/logo.png")} alt="react-logo" />
            </div>
          </a>
          <a className="simple-text logo-normal orange-color">
            MGSVY
            <span className="sidebar-role">{this.state.userRole ? this.state.userRole.name : ''}</span>
          </a>
        </div>
        <div className="sidebar-wrapper" ref={this.sidebar}>
          <ul className="nav">
            {this.props.routes.map((prop, key) => {
              return (
                (prop.subRoutes && prop.subRoutes.length > 0) ?
                  prop.canShowInSideBar &&
                  <li className={
                    this.isSubROute(prop.subRoutes, "active") +
                    (prop.pro ? " active-pro" : "")
                  }
                    key={key}>
                    <a className="sidemenu-item" data-toggle="collapse" href={`#${prop.id}`} aria-expanded={this.isSubROute(prop.subRoutes) == 'show'}>
                      <i className={prop.icon}></i>
                      <p className="sidemenu-label">{prop.name} <b className="caret sidebar-caret"></b></p>
                    </a>
                    <div
                      className={`collapse in ${this.isSubROute(prop.subRoutes, "show")}`}
                      id={prop.id}>
                      <ul className="nav">
                        {
                          prop.subRoutes.filter(sRoute => sRoute.canShowInSideBar).map((subRoute, subRouteIndex) => {
                            return (
                              <li className={
                                this.activeRoute(subRoute.path, "active") +
                                (prop.pro ? " active" : "")
                              }
                                key={subRouteIndex}>
                                <NavLink to={prop.layout + subRoute.path}>
                                  <p className="sidemenu-label">&nbsp;&nbsp;&nbsp;⚫ &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {subRoute.name}</p>
                                </NavLink>
                              </li>
                            )
                          })}
                      </ul>
                    </div>
                  </li>
                  :
                  prop.canShowInSideBar &&
                  <li className={
                    this.activeRoute(prop.path, "active") +
                    (prop.pro ? " active-pro" : "")
                  }
                    key={key}>
                    <NavLink className="sidemenu-item" to={prop.layout + prop.path}>
                      <i className={prop.icon}></i>
                      <p>{prop.name}</p>
                    </NavLink>
                  </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}

export default Sidebar;
